import request from '@/utils/request';

export function login(data: { account: string; password: string }) {
  return request.post('/auth/login', data);
}

export function register(data: { username: string; email: string; password: string; inviteCode?: string }) {
  return request.post('/auth/register', data);
}

export function refreshToken(refreshToken: string) {
  return request.post('/auth/refresh', { refreshToken });
}

export function getMyPermissions() {
  return request.get('/auth/my-permissions');
}

export function changePassword(oldPassword: string, newPassword: string) {
  return request.post('/auth/change-password', { oldPassword, newPassword });
}
